export const mapClaimResponses = (
  patientDetails: Record<string, string>,
  claimResponses: any
) => {
  return claimResponses.map((claimResponse: any) => {
    // Extract patient ID from the claim response
    const patientReference = claimResponse.patient.reference;
    const patientId = patientReference.split("/")[1]; // Get the ID part of the reference

    // Retrieve the patient name from the patientDetails object
    const patientName = patientDetails[patientId] || "Unknown Patient"; // Fallback to "Unknown Patient" if not found

    // Return the desired claim response information along with the patient name
    return {
      patientName, // Retrieved or fallback patient name
      claimId: claimResponse.id, // Claim ID
      provider: claimResponse?.requestor?.display??'--', // Claim ID
      type: claimResponse.type?.coding?.[0]?.display || "--", // Claim type display (e.g., "Institutional")
      subType: claimResponse.subType?.coding?.[0]?.display || "--", // Claim subtype (e.g., "Emergency Claim")
      created: claimResponse.created, // Date of creation
      insurer: claimResponse.insurer.display??'--', // Insurer information
      outcome: claimResponse.outcome, // Outcome/status of the claim (e.g., "partial")
      paymentAmount: claimResponse.payment?.amount?.value || 0, // Payment amount if present
    };
  });
};
